import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';

@Component({
  selector: 'app-question-spacer',
  templateUrl: './question-spacer.component.html',
  styleUrls: ['./question-spacer.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionSpacerComponent implements OnInit {

  @Input() questionSpacer: number;
  @Input() BottomPosition: boolean;

  constructor(private service: ParticipationDataService) { }

  ngOnInit() {
    if(this.BottomPosition){
      if(this.service.getCommonSetting().isEmbedPopMobile || this.service.getCommonSetting().isEmbedPopWeb)
      {
        this.questionSpacer = this.service.getCommonSetting().embedPopQSpacer;
      }
      else
      {
        this.questionSpacer = this.questionSpacer == undefined ? 35 : this.questionSpacer-5;
      }
    }
    else{
      this.questionSpacer = 5;
    }

  }

}
